/**
 * Created by oreuveni
 * Date: 2019-01-15
 * Time: 17:07
 */
import encodeurl from 'encodeurl';
import {
    saveCreative as campaignsSaveCreative,
    saveBrandsVideoCreative,
    saveRssCreative,
    updateAd,
} from 'modules/campaigns/flows';
import {
    isBrandsVideoCreative,
    isCreativeLibraryEnabled,
    isLibraryCreative,
    isRssChild,
} from 'modules/campaigns/modules/campaigns-reports/config/predicates';
import selectedAccountSelector from 'selectors/selectedAccount';

const saveCreative = (newValue, creative, _oldValue, _rowIndex, _fieldValue, context) => (dispatch, getState) => {
    const { accountName } = creative;
    const { accountId } = selectedAccountSelector(getState());
    const { url } = newValue;
    const savedValue = url ? { ...newValue, url: encodeurl(url) } : newValue;
    const isLibraryEnabled = isCreativeLibraryEnabled(context?.selectedAccountConfig);

    if (isLibraryEnabled && isLibraryCreative({ data: creative })) {
        dispatch(updateAd(accountName, creative, savedValue));
    } else if (isRssChild(creative)) {
        dispatch(saveRssCreative(accountName || accountId, creative, savedValue));
    } else if (isBrandsVideoCreative(creative)) {
        dispatch(saveBrandsVideoCreative(accountName || accountId, creative, savedValue));
    } else {
        dispatch(campaignsSaveCreative(accountName || accountId, creative, savedValue));
    }
};

export default saveCreative;
